// extracted by mini-css-extract-plugin
export default {"wrapper":"additional-info_wrapper__MKqz7","items":"additional-info_items__-3rTF","subtitle":"additional-info_subtitle__wHv6S","value":"additional-info_value__gElSG"};